function addToCart(variantId, count) {
  let quantity 
  if(!count){
    const quantityDisplay = document.getElementById('product-quantity')
    quantity = Number(quantityDisplay?.textContent) || 1
  }else{
  quantity = count
  }
  const loadingSpinner = document.getElementById(`loading-spinner-${variantId}`)
  if(loadingSpinner){
    loadingSpinner.style.display = 'flex';
  }
  const cartIcon = document.getElementById(`cart-icon-${variantId}`)
  if(cartIcon){
    cartIcon.style.display = 'none';
  }

  const data = {
    items: [
      {
        id: variantId,
        quantity: quantity,
      },
    ],
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Failed to add item to cart');
      }
    })
    .then((cart) => {
      updateCartCount(cart);
      updateDisplay();
      if(loadingSpinner){
        loadingSpinner.style.display =  'none';
      }
      if(cartIcon){
        cartIcon.style.display = 'block';
      }
      document.getElementById('cart-menu').style.right = 0;
      document.body.style.overflow = 'hidden';
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
      showNotification('Error adding to cart.... Please try again!');
    });
}

function buyNow(variantId, count) {  
  let quantity 
  if(!count){
    const quantityDisplay = document.getElementById('product-quantity')
    quantity = Number(quantityDisplay.textContent || 1)
  }else{
  quantity = count
  }

  // Add product to cart
  fetch(`/cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity }),
  })
    .then(() => {
      // Redirect to checkout
      window.location.href = '/checkout';
    })
    .catch((error) => console.error('Error adding product to cart:', error));
}

function updateCartCount(cart) {
  const cartCountElement = document.getElementById('cart-menu-item-count');
  if (cartCountElement) {
    cartCountElement.innerText = cart?.items?.length;
  }
}

function updateDisplay() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      updateCartDisplay(cart);
    })
    .catch((error) => console.error('Error fetching cart data:', error));
}

function showNotification(message) {
  alert(message);
}

function updateCartDisplay(cart) {
  const cartMenuItems = document.getElementById('cart-menu-items');
  cartMenuItems.innerHTML = '';

  if (cart.items.length > 0) {
    document.getElementById('cart-menu-footer').style.display = 'flex';
    document.getElementById('cart-menu-items').style.display = 'block';
    document.getElementById('cart-empty-text').style.display = 'none';
    document.getElementById('cart-badge').style.display = 'flex';
    document.getElementById('cart-badge-mobile').style.display = 'flex';

    cart.items.forEach((item) => {
      const itemHTML = `
  <div class="cart-menu-item" data-id="${item.id}">
    <div class="card-item-left">
      <div class="cart-menu-item-image-container">
        <img loading="lazy"
          class="cart-menu-item-image"
          width=""
          height=""
          src="${item.image}"
          alt="${item.product_title}"
        >
      </div>
      <div class="cart-item-details">
        <p class="cart-item-title">${item.product_title}</p>
        <p class="cart-item-price">${formatPrice(item.line_price)}</p>
        <div class="cart-item-controls">
          <div onclick="changeQuantity('${item.id}', -1)" class="cart-item-control pointer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19" stroke="#151515" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
          </div>
          <p class="cart-item-quantity">${item.quantity}</p>
          <div onclick="changeQuantity('${item.id}', 1)" class="cart-item-control pointer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19" stroke="#151515" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 12H19" stroke="#151515" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="pointer" onclick="removeFromCart('${item.id}')">
     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 6H5H21" stroke="#151515" stroke-opacity="0.55" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#151515" stroke-opacity="0.55" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10 11V17" stroke="#151515" stroke-opacity="0.55" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14 11V17" stroke="#151515" stroke-opacity="0.55" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
     </svg>
    </div>
  </div>
`;
      cartMenuItems.insertAdjacentHTML('beforeend', itemHTML);
    });

    // Update subtotal
    document.getElementById('cart-item-subtotal').textContent = formatPrice(cart.total_price);
    document.getElementById('cart-badge-count').textContent = cart.items.length;
    document.getElementById('cart-badge-count-mobile').textContent = cart.items.length;
  } else {
    document.getElementById('cart-menu-footer').style.display = 'none';
    document.getElementById('cart-menu-items').style.display = 'none';
    document.getElementById('cart-empty-text').style.display = 'block';
    document.getElementById('cart-badge').style.display = 'none';
    document.getElementById('cart-badge-mobile').style.display = 'none';

  }
}

// Utility function to format price
function formatPrice(priceInCents) {
  const formattedPrice = (priceInCents / 100).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `€${formattedPrice}`;
}

function changeQuantity(itemId, quantityChange) {
  // Find the item in the cart
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const item = cart.items.find((item) => item.id == itemId);

      if (!item) {
        alert('Item not found in cart');
        return;
      }

      const newQuantity = item.quantity + quantityChange;

      if (newQuantity < 0) {
        alert("Quantity can't be negative");
        return;
      }

      // Update the cart line with new quantity
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemId,
          quantity: newQuantity,
        }),
      })
        .then((response) => response.json())
        .then((updatedCart) => {
          // Update the cart display with new data
          updateCartDisplay(updatedCart);
          updateCartCount(updatedCart);
        })
        .catch((error) => console.error('Error updating quantity:', error));
    })
    .catch((error) => console.error('Error fetching cart data:', error));
}

function removeFromCart(itemId) {
  const url = `/cart/update.js`;
  const data = {
    updates: {
      [itemId]: 0, // Setting quantity to 0 removes the item
    },
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Failed to remove item from cart');
      }
    })
    .then((cart) => {
      console.log('Item removed:', cart);
      updateCartDisplay(cart); // Function to update the cart UI
      updateCartCount(cart);
    })
    .catch((error) => {
      console.error('Error removing from cart:', error);
    });
}